import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["card", "column", "count", "empty"];
  static values = { error: String };

  connect() {
    this.draggedCard = null;
    this.originColumn = null;
  }

  dragStart(event) {
    this.draggedCard = event.currentTarget;
    this.originColumn = this.draggedCard.closest("[data-ticket-board-target='column']");
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", this.draggedCard.id);
    this.draggedCard.classList.add("opacity-50");
  }

  dragEnd() {
    this.draggedCard?.classList.remove("opacity-50");
  }

  allowDrop(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }

  async drop(event) {
    event.preventDefault();
    const destination = event.currentTarget;

    if (!this.draggedCard || destination === this.originColumn) return;

    const origin = this.originColumn;
    destination.querySelector("[data-ticket-cards]").append(this.draggedCard);
    this.refreshColumn(origin);
    this.refreshColumn(destination);

    const response = await fetch(this.draggedCard.dataset.statusUrl, {
      method: "PATCH",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      },
      body: JSON.stringify({ status: destination.dataset.status })
    });

    if (!response.ok) {
      origin.querySelector("[data-ticket-cards]").append(this.draggedCard);
      this.refreshColumn(origin);
      this.refreshColumn(destination);
      window.alert(this.errorValue);
    }
  }

  refreshColumn(column) {
    const cards = column.querySelectorAll("[data-ticket-board-target='card']");
    column.querySelector("[data-ticket-board-target='count']").textContent = cards.length;
    column.querySelector("[data-ticket-board-target='empty']")?.classList.toggle("hidden", cards.length > 0);
  }
}
